import React from "react";
import { useLang } from "@/context/LanguageContext";
import { motion } from "framer-motion";
import { Truck, Building2, MapPinned, PackageOpen, Wrench, Boxes } from "lucide-react";

const ICONS = [Truck, MapPinned, Building2, PackageOpen, Wrench, Boxes];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-primary font-bold">01 / Services</div>
          <h2 className="mt-4 text-4xl md:text-5xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
            {t.services.title}
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">{t.services.subtitle}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="group relative rounded-xl border border-border bg-card p-6 hover:border-primary/60 transition-colors"
                data-testid={`service-card-${i}`}
              >
                <div className="h-11 w-11 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 text-xl font-semibold" style={{ fontFamily: "Outfit" }}>{s.name}</h3>
                <p className="mt-2 text-muted-foreground text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
